import {
  AccountType,
  DestinationType,
  TransferDestinationPlanType,
} from "manifest-components/src/classes/transferDestination";
import TransferInstruction, { NewTransferStatusType } from "manifest-components/src/classes/transferInstruction";
import { SalaryRange } from "manifest-components/src/classes/transferSource";

const sampleTransferInstruction = {
  transferInstructionId: 20000,
  transferInstructionStatus: NewTransferStatusType.WAIT_FOR_IRA_OPENING,
  transferExternalStatusDescription: "",
  scheduledPhoneCall: null,
  source: {
    planSponsor: "Meta Platforms, Inc.",
    terminatedYear: "null",
    startYear: "Above $110,000",
    salaryRange: "Above $110,000" as SalaryRange,
    transferId: 30601,
    providerSkipped: true,
    providerName: "",
    sourceAccountIs401k: false,
    statementSkipped: false,
    aggregatorSkipped: true,
    aggregatorLink: undefined,
  },
  destinations: [
    {
      aggregatorUpdateRequired: false,
      destinationAccountId: 31355,
      destinationType: "DESTINATION" as DestinationType,
      destinationAccountType: "IRA" as AccountType,
      planSponsor: "null",
      planName: "null",
      planNumber: "null",
      planType: "BOTH" as TransferDestinationPlanType,
      traditionalIraAccountNumber: "1234",
      rothIraAccountNumber: "null",
      yetToOpen: false,
      accountOpeningUrl: "null",
      providerName: "Betterment",
      statementSkipped: true,
      destinationStatementFileNames: [],
      aggregatorSkipped: true,
      transferId: 123456,
      aggregatorLink: undefined,
      reallocation: null,
      skipReallocation: null,
    },
  ],
  transferId: 30601,
};

export const testTransferInstructionData: TransferInstruction[] = [
  // WAIT FOR IRA OPENING
  TransferInstruction.fromAPI({
    ...sampleTransferInstruction,
    transferInstructionId: 20000,
    transferInstructionStatus: NewTransferStatusType.WAIT_FOR_IRA_OPENING,
    transferExternalStatusDescription: "Manifest is processing your transfer; no action is needed.",
  }),
  // PROCESSING
  TransferInstruction.fromAPI({
    ...sampleTransferInstruction,
    transferInstructionId: 20001,
    transferInstructionStatus: NewTransferStatusType.PROCESSING,
    transferExternalStatusDescription: "Manifest is processing your transfer; no action is needed.",
  }),
  // INITIATED AT SOURCE
  TransferInstruction.fromAPI({
    ...sampleTransferInstruction,
    transferInstructionId: 20002,
    transferInstructionStatus: NewTransferStatusType.INITIATED_AT_SOURCE,
    transferExternalStatusDescription: "Your transfer has been initiated at the source provider.",
  }),
  // CHECK SENT DESTINATION
  TransferInstruction.fromAPI({
    ...sampleTransferInstruction,
    transferInstructionId: 20003,
    transferInstructionStatus: NewTransferStatusType.CHECK_SENT_TO_DESTINATION,
    transferExternalStatusDescription: "A check has been issued and sent to your destination account.",
  }),
  // ADDITIONAL INFORMATION NEEDED
  TransferInstruction.fromAPI({
    ...sampleTransferInstruction,
    transferInstructionId: 20004,
    transferInstructionStatus: NewTransferStatusType.ADDITIONAL_INFORMATION_NEEDED,
    transferExternalStatusDescription:
      "Additional details are needed to complete your transfer. Your transfer specialist will follow up.",
  }),
  // TRANSFER COMPELTE
  TransferInstruction.fromAPI({
    ...sampleTransferInstruction,
    transferInstructionId: 20005,
    transferInstructionStatus: NewTransferStatusType.COMPLETE,
    transferExternalStatusDescription: "Your transfer has been completed successfully.",
  }),
  TransferInstruction.fromAPI({
    ...sampleTransferInstruction,
    transferInstructionId: 20006,
    transferInstructionStatus: NewTransferStatusType.CANCELLED,
    transferExternalStatusDescription:
      "Your transfer has been canceled. For questions, contact transfers@usemanifest.com",
  }),
  //   new TransferInstruction(),
  //   new TransferInstruction(),
  //   new TransferInstruction(),
  //   new TransferInstruction(),
  //   new TransferInstruction(),
  //   new TransferInstruction(),
];
